import { render, staticRenderFns } from "./WorkerInfoContext.vue?vue&type=template&id=04515dcc&scoped=true"
import script from "./WorkerInfoContext.vue?vue&type=script&lang=js"
export * from "./WorkerInfoContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04515dcc",
  null
  
)

export default component.exports